<template>
  <div class="ActiveDirectory">
    <box :title="$t('nav-active-directory')">
      <div class="pa-2">
        <v-row>
          <v-switch
            :loading="loadingEnableActiveDir"
            :disabled="disableActiveDir"
            dense
            inset
            v-model="swActiveDir"
            label="ورود از طریق اکتیو دایرکتوری"
            @change="changeActiveDir"
          ></v-switch>
        </v-row>
        <!-- <v-row>
          <v-col cols="3" sm="2"
            ><label class="my-auto">نام دامنه</label></v-col
          >
          <v-col class="px-1" cols="9" sm="4" md="3"
            ><v-text-field
              v-model="txtActiveDirectoryName"
              hide-details=""
              solo
              dense
              placeholder="نام دامنه"
          /></v-col>
          <v-col class="px-1" cols="12" sm="4" md="3"
            ><v-btn block color="primary" @click="btnSaveActiveClick"
              >ذخیره نام دامنه</v-btn
            ></v-col
          >
        </v-row> -->
        <v-row class="mt-2">
          <v-col class="px-1" cols="9" sm="4" md="3">
            <v-file-input
              placeholder="انتخاب فایل"
              persistent-hint
              hint="فایل txt یا csv - جدا شده با ;"
              solo
              dense
              prepend-icon=""
              prepend-inner-icon="mdi-file-document-outline"
              @change="changeFile"
            />
          </v-col>
          <v-col class="px-1" cols="12" sm="4" md="3">
            <v-btn block color="primary" @click="btnUploadExcelClick"
              >خواندن و اعمال فایل</v-btn
            ></v-col
          >
        </v-row>

        <v-alert
          class="mt-2"
          text
          dense
          color="teal"
          icon="mdi-comment-alert-outline"
          border="left"
        >
          راهنما: فایل باید شامل نام کاربری دامنه و کد پرسنلی به فرمت هر خط یک
          کاربر و به شکل کد پرسنلی; نام کاربری دامنه باشد. کد پرسنلی در سمت چپ
          نام کاربری باید وارد شود.
        </v-alert>

        <div v-if="personList.length > 0">
          <active-directory-person-list-web
            :list="personList"
            class="hidden-sm-and-down"
          />
          <active-directory-person-list-mob
            :list="personList"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import ActiveDirectoryPersonListMob from "../../../components/admin/activeDirectory/ActiveDirectoryPersonListMob.vue";
import ActiveDirectoryPersonListWeb from "../../../components/admin/activeDirectory/ActiveDirectoryPersonListWeb.vue";
import EosToastType from "../../../model/EosToastType";
import ResultType from "../../../model/ResultType";
export default {
  components: { ActiveDirectoryPersonListWeb, ActiveDirectoryPersonListMob },
  data() {
    return {
      txtActiveDirectoryName: "",
      personList: [],
      file: null,
      swActiveDir:false,
      loadingEnableActiveDir: false,
      disableActiveDir: true,
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    changeActiveDir() {
      this.loadingEnableActiveDir = true;
      this.disableActiveDir = true;

      if (this.txtActiveDirectoryName) {
        this.txtActiveDirectoryName = "";
      } else {
        this.txtActiveDirectoryName = "eos";
      }
      this.btnSaveActiveClick();
    },
    pageLoad() {
      this.disableActiveDir = true;
      this.$store.dispatch("readwebkartsetting").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          var setting = result.data;
          this.txtActiveDirectoryName = setting.ActiveDirectoryName;
          if(this.txtActiveDirectoryName){
            this.swActiveDir = true
          } else{
            this.swActiveDir = false
          }
          this.disableActiveDir = false;
        }
      });

      this.getEosPersons();
    },
    getEosPersons() {
      var perno = "eosWebKartAdmin";
      var sectionCode = "";
      this.$store
        .dispatch("EosPerson", { perno, sectionCode })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            this.personList = result.data.Table;
          }
        });
    },
    btnSaveActiveClick() {
      var activeDirectoryName = this.txtActiveDirectoryName;
      this.$store
        .dispatch("SetActiveDirectory", { activeDirectoryName })
        .then((result) => {
          //console.log(result);
          if (result.type == ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: "تغییرات اعمال گردید.",
            });
            this.loadingEnableActiveDir = false;
            this.disableActiveDir = false;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("operationFailed"),
            });
            this.txtActiveDirectoryName = "";
            this.loadingEnableActiveDir = true;
            this.disableActiveDir = true;
          }
        });
    },
    btnUploadExcelClick() {
      /**
       *
       */

      if (this.file) {
        if (
          this.file.type != "text/plain" &&
          this.file.type != "application/vnd.ms-excel"
        ) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "فرمت فایل انتخاب شده صحیح نمی باشد.",
          });
          return;
        }
        try {
          var promises = [];

          var reader = new FileReader();
          reader.onload = (e) => {
            var f = e.target.result;
            var lines = f.split("\n");
            lines.forEach((line) => {
              //console.log(line.replace(" ", ""));
              var partsOfString = line
                .replace(" ", "")
                .toString()
                .trim()
                .split(";");
              console.log(partsOfString);

              var UpdateDomainUserNameParams = {
                domainUsername: partsOfString[1],
                perno: partsOfString[0],
              };

              promises.push(
                this.$store.dispatch("UpdateDomainUserName", {
                  UpdateDomainUserNameParams,
                })
              );
            });
          };

          reader.addEventListener("loadend", () => {
            console.log("loadend");
            Promise.all(promises).then((results) => {
              console.log(results);
              var fail = results.find(
                (result) => result.type != ResultType.success
              );
              if (!fail && results.length > 0) {
                this.$EosToast.show({
                  type: EosToastType.success,
                  msg: "اطلاعات کاربران بروز رسانی گردید.",
                });
                this.getEosPersons();
              } else {
                this.$EosToast.show({
                  type: EosToastType.error,
                  msg: "بروز خطا در خواندن فایل، لطفا فایل را مجددا بررسی کنید.",
                });
              }
            });
          });

          reader.readAsText(this.file);
        } catch {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "بروز خطا در خواندن فایل، لطفا فایل را مجددا بررسی کنید.",
          });
          return;
        }
      } else {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "لطفا فایل مورد نظر را انتخاب کنید.",
        });
        return;
      }
    },
    changeFile(file) {
      //console.log(file);
      this.file = file;
      if (this.file) {
        if (
          this.file.type != "text/plain" &&
          this.file.type != "application/vnd.ms-excel"
        ) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "فرمت فایل انتخاب شده صحیح نمی باشد.",
          });
          return;
        }
      }
    },
  },
};
</script>

<style>
</style>